import {http} from '@/utils/http';

const URL = '/api/pleaseLogThis';

export const sendLogMessage = async (message: string): Promise<void> => {
  await http.post(URL, `[USF] ${message}`);
};
